import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let goodsSwiperWr = document.querySelectorAll('.goods-swiper-wr');
goodsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let pagination = el.querySelector('.swiper-pagination');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
     let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      speed: 500,
      threshold: 10,
      slidesPerView: 'auto',
      spaceBetween: 20,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },

      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      }
    });
    swiperObserver(swiper);
  }
});
